import { MarketingNav, Footer } from "@/components/marketing/MarketingNav";
import { Link } from "react-router-dom";
import { MODULES } from "@/pages/app/LearnCenter";
import { GraduationCap, ArrowRight } from "lucide-react";

export default function LearnPublic() {
  return (
    <div className="bg-[var(--bg)] text-[var(--text)] min-h-screen">
      <MarketingNav />
      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="flex items-center gap-3"><GraduationCap className="text-aurum" /><span className="text-xs uppercase tracking-wider text-aurum font-medium">Learning Center</span></div>
        <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold tracking-tight">Learn the craft. No hype.</h1>
        <p className="mt-4 text-[var(--text-sec)] max-w-xl">Structured modules on market structure, risk, psychology and process. No module promises profits — because none can.</p>
        <div className="mt-12 space-y-8">
          {MODULES.map((m) => (
            <div key={m.cat}>
              <div className="text-xs uppercase tracking-wider text-[var(--text-muted)]">{m.cat}</div>
              <div className="mt-3 flex flex-wrap gap-2">
                {m.items.map((it) => (
                  <span key={it} className="rounded-full border border-[var(--border2)] bg-[var(--card2)] px-4 py-2 text-sm text-[var(--text-sec)]">{it}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <Link to="/signup" className="mt-12 inline-flex items-center gap-2 btn-gold rounded-full px-6 py-3 text-sm font-semibold hover:brightness-110">Access full lessons free <ArrowRight size={16} /></Link>
      </section>
      <Footer />
    </div>
  );
}
